import { set, get } from "./state.js";
import { loggedIn, updateScoreDisplay } from "./app.js";
import { addQuestionsElement, resetQuestionAnswers } from "./questions.js";
import { podcast } from "./podcast.js";
import useGrpc from "./grpc.js";
import useAuth from "./firebase.js";
import alertify from "alertifyjs";

const grpc = useGrpc();
const auth = useAuth();

let activePlayer = null;

let playlog = null;

export function setCurrentVideo(videoUrl) {
  return set("currentVideo", videoUrl, "session");
}

export function getCurrentVideo() {
  return get("currentVideo", "session");
}

function networkError(error) {
  alertify.error(
    "Network error! Will try to load leaderboard data again shortly."
  );
  console.error(error);
}

function answerCallback(lightboxWrapper, score, videoPlayer) {
  return function (answers) {
    if (Object.keys(answers).length < 2) {
      return;
    }

    score = Math.round(videoPlayer.duration / 60);

    console.log("Sending score for watched video: " + score);

    console.log(
      "answers",
      Object.values(answers).map((ans) => (ans === "YES" ? "Yes" : "No"))
    );

    if (get("accountType") == "0") {
      auth
        .ready()
        .then(() =>
          grpc
            .watchedVideo(
              getCurrentVideo(),
              Object.values(answers).map((ans) =>
                ans === "YES" ? "Yes" : "No"
              )
            )
            .then((res) => {
              console.log(res);

              set("score", res.newScore);
              updateScoreDisplay();
              addBadgesToVideoThumbnails();
              resetQuestionAnswers();
            })
        )
        .catch(networkError);
    } else {
      alertify.error(
        "You must be a 10th grade student to earn points for watching videos."
      );
    }

    document.body.removeChild(lightboxWrapper);
  };
}

export function initVideoPlayer(lightboxWrapper) {
  const videoPlayerId = "itp-video-player";

  let currentVideoParts = getCurrentVideo().split("/");
  let videoId = currentVideoParts[currentVideoParts.length - 1];

  let videoPlayerStyle = document.createElement("style");
  videoPlayerStyle.type = "text/css";
  videoPlayerStyle.innerHTML = `
		.itpVideoPlayerWrapper {
			width:60%;
			display:inline-block;
			max-height: 60%;
		}
		@media only screen and (max-width:600px) {
			.itpVideoPlayerWrapper {
				width:100%;
			}
		}
	`;

  document.body.appendChild(videoPlayerStyle);

  let videoPlayerWrapper = document.createElement("div");
  //videoPlayerWrapper.style.width = '60%';
  //videoPlayerWrapper.style.display = 'inline-block';
  //videoPlayerWrapper.style.maxHeight = '60%';
  let wrapperClasses = videoPlayerWrapper.className;

  let videoPlayerElement = document.createElement("div");

  videoPlayerElement.id = videoPlayerId;

  videoPlayerElement.setAttribute("data-plyr-provider", "youtube");
  videoPlayerElement.setAttribute("data-plyr-embed-id", videoId);

  lightboxWrapper.appendChild(videoPlayerWrapper);
  videoPlayerWrapper.className = wrapperClasses + " itpVideoPlayerWrapper";

  videoPlayerWrapper.appendChild(videoPlayerElement);

  if (playlog) {
    const played = playlog?.playedList?.find(
      (v) => v.url === `https://youtu.be/${videoId.split("v=")[1]}`
    );

    if (played) {
      // create an element that says "You've watched this video"
      // and add it to the lightboxWrapper
      const watched = document.createElement("div");
      watched.innerHTML =
        "You've already earned points for watching this video.";
      watched.style.color = "white";
      watched.style.backgroundColor = "green";
      watched.style.fontSize = "1.5em";
      watched.style.fontWeight = "bold";
      watched.style.textAlign = "center";
      watched.style.marginTop = "1em";
      watched.style.padding = "1em";
      lightboxWrapper.appendChild(watched);
    }
  }

  if (!loggedIn()) {
    const watched = document.createElement("div");
    watched.innerHTML =
      "You must be logged in to earn points for watching videos.";
    watched.style.color = "white";
    watched.style.backgroundColor = "red";
    watched.style.fontSize = "1.5em";
    watched.style.fontWeight = "bold";
    watched.style.textAlign = "center";
    watched.style.marginTop = "1em";
    watched.style.padding = "1em";
    lightboxWrapper.appendChild(watched);
  }

  return new Plyr("#" + videoPlayerId, {
    controls: ["play-large", "play", "fullscreen"],
    autoplay: true,
    keyboard: { focused: false, global: false },
    seekTime: 0.001,
  });
}

export function buildVideoPlayerLightbox(parentElement, score) {
  let docWidth =
    window.innerWidth || document.clientWidth || document.body.clientWidth;

  const lightboxWrapper = document.createElement("div");
  lightboxWrapper.style.position = "fixed";
  lightboxWrapper.style.overflow = "auto";
  lightboxWrapper.style.top = 0;
  lightboxWrapper.style.bottom = 0;
  lightboxWrapper.style.left = 0;
  lightboxWrapper.style.right = 0;
  lightboxWrapper.style.backgroundColor = "rgba(0,0,0,0.6)";
  lightboxWrapper.style.zIndex = "10001";

  if (docWidth > 600) {
    lightboxWrapper.style.padding = "5rem";
  }

  lightboxWrapper.style.textAlign = "center";

  parentElement.appendChild(lightboxWrapper);

  const videoPlayer = initVideoPlayer(lightboxWrapper);
  videoPlayer.on("statechange", (event) => {
    if (event.detail.code == 0) {
      if (loggedIn()) {
        console.log("Duration is " + videoPlayer.duration);
        let newScore = Math.round(videoPlayer.duration / 60);
        addQuestionsElement(
          lightboxWrapper,
          answerCallback(lightboxWrapper, newScore, videoPlayer)
        );
      }
    }
  });
  videoPlayer.onkeypress = function (e) {
    e = e || window.event;
    var charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);
    if (/\d/.test(charStr)) {
      return false;
    }
  };

  activePlayer = videoPlayer;

  videoPlayer.on("cuechange", () => {
    // set cue back to 0
    videoPlayer.currentTime = 0;
  });

  const lightboxClose = document.createElement("h3");
  lightboxClose.innerHTML = "&times;";
  lightboxClose.style.zIndex = "10002";
  lightboxClose.style.color = "white";
  lightboxClose.style.position = "fixed";

  if (docWidth > 600) {
    lightboxClose.style.top = "40px";
    lightboxClose.style.right = "40px";
  } else {
    lightboxClose.style.top = "0px";
    lightboxClose.style.right = "0px";
  }

  lightboxClose.style.padding = "10px";
  lightboxClose.style.fontSize = "5rem";
  lightboxClose.style.cursor = "pointer";
  lightboxClose.onclick = (e) => {
    document.body.removeChild(lightboxWrapper);
    resetQuestionAnswers();
  };

  lightboxWrapper.appendChild(lightboxClose);

  return lightboxWrapper;
}

export function loadVideoPlayer(score, getHref) {
  return (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    console.log("In loadVideoPlayer");
    console.log(evt);
    console.log(evt.target);

    if (!setCurrentVideo(getHref(evt))) {
      alertify.error(
        "There was an error setting the currently watched video. Try refreshing the page."
      );
    }

    let lightbox = buildVideoPlayerLightbox(document.body, score);

    return false;
  };
}

function setVideoClickHandler() {
  for (let video of document.querySelectorAll(".video-popup")) {
    video.onclick = loadVideoPlayer(0, (evt) => evt.target.parentElement.href);
  }
}

const addBadgesToVideoThumbnails = async () => {
  playlog = await grpc.getUserPlayLog();

  const videos = await grpc.getAllVideos();

  const vids = document.querySelectorAll(".video-popup");
  vids.forEach((vid) => {
    const vidId = vid.href.split("v=")[1];
    const vidData = videos.videosList.find((v) => {
      const parts = v.url.split("/");
      const id = parts[parts.length - 1];
      return id === vidId;
    });

    if (vidData) {
      jQuery(vid).parent().remove("itp-video-time-badge");
      // duration badge
      jQuery(vid)
        .parent()
        .append(
          `<div class="itp-video-time-badge" style="padding: 2px; background: blue; color: white; position: absolute; bottom:0; right:0; font-size: 12pt;"><span>${vidData.score} Mins</span></div>`
        );
    }

    const item = playlog.playedList.find(
      (v) => v.url === `https://youtu.be/${vidId}`
    );
    if (item) {
      // use jquery to add a green badge with white text and a little padding in the top left corner of the parent that says "watched"
      jQuery(vid).parent().remove("itp-video-played-badge");

      jQuery(vid)
        .parent()
        .css({
          position: "relative",
        })
        .append(
          `<div class="itp-video-played-badge" style="padding: 2px; background: green; color: white; position: absolute; top:0; left:0; font-size: 12pt;"><span>Completed</span></div>`
        );

      jQuery(vid)
        .parent()
        .append(
          `<div class="itp-video-time-badge" style="padding: 2px; background: blue; color: white; position: absolute; bottom:0; right:0; font-size: 12pt;"><span>Earned ${item.score} Points</span></div>`
        );
    }
  });
};

// entry point
export function videos() {
  setVideoClickHandler();

  for (let btn of document.querySelectorAll(".eael-gallery-load-more")) {
    btn.onclick = function (e) {
      setVideoClickHandler();
      addBadgesToVideoThumbnails();
    };
  }

  let topVideo = document.querySelector(".itp-pathway-top-video a");

  if (topVideo != null) {
    topVideo.onclick = loadVideoPlayer(10, (evt) => {
      return evt.target.parentElement.href;
    });
  }

  for (let video of document.querySelectorAll(
    ".elementor-custom-embed-image-overlay"
  )) {
    video.onclick = loadVideoPlayer(10, (evt) => {
      let iframe = document.querySelector(".elementor-video-iframe");
      let iframeSrc = iframe.src;
      iframe.remove();
      return iframeSrc;
    });
  }

  document.body.onclick = function (e) {
    setVideoClickHandler();
  };

  podcast();

  auth.ready().then(async () => {
    await addBadgesToVideoThumbnails();
  });

  jQuery(document).ready(function () {
    window.addEventListener("focus", () => activePlayer?.play());
    window.addEventListener("blur", () => activePlayer?.pause());
  });
}

export default {};
